export default __webpack_public_path__ + "a2aa89f5558ec398638861ddc96057fe.png";